import { render, staticRenderFns } from "./ResolverPanel.vue?vue&type=template&id=584ec490&"
import script from "./ResolverPanel.vue?vue&type=script&lang=js&"
export * from "./ResolverPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584ec490')) {
      api.createRecord('584ec490', component.options)
    } else {
      api.reload('584ec490', component.options)
    }
    module.hot.accept("./ResolverPanel.vue?vue&type=template&id=584ec490&", function () {
      api.rerender('584ec490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/ResolverPanel.vue"
export default component.exports